import { atom } from "recoil"

const inchatNoticeContentsState = atom({
  key: 'inchatNoticeContents',
  default: '',
});

export default inchatNoticeContentsState;
